import * as THREE from 'three'
import gsap from 'gsap'

export default class Camera
{
    constructor(_options)
    {
        this.time = _options.time
        this.sizes = _options.sizes
        this.renderer = _options.renderer
        this.container = new THREE.Object3D()
        this.target = new THREE.Vector3()
        this.targetEased = new THREE.Vector3()
        this.focus = new THREE.Vector3()
        this.player = new THREE.Vector3()
        this.angle = new THREE.Vector3(1, -1.45, 1.4).normalize()
        this.distance = 22
        this.setZoomLimits()
        this.distance = this.zoomLimits.max
        this.revealing = false

        this.instance = new THREE.PerspectiveCamera(38, this.sizes.viewport.width / this.sizes.viewport.height, 0.1, 100)
        this.instance.up.set(0, 0, 1)
        this.container.add(this.instance)

        this.sizes.on('resize', () =>
        {
            this.instance.aspect = this.sizes.viewport.width / this.sizes.viewport.height
            this.instance.updateProjectionMatrix()
            this.setZoomLimits()
        })

        this.renderer.domElement.addEventListener('wheel', (_event) =>
        {
            this.zoomBy(_event.deltaY * 0.012)
        }, { passive: true })

        this.time.on('tick', () =>
        {
            const delta = Math.min(this.time.delta / 1000, 0.06)
            if(!this.revealing)
                this.target.copy(this.player)

            const easing = 1 - Math.exp(- delta * 5)
            this.targetEased.lerp(this.target, easing)
            this.instance.position.copy(this.targetEased).addScaledVector(this.angle, this.distance)
            this.instance.lookAt(this.targetEased)
        })
    }

    setZoomLimits()
    {
        this.zoomLimits = this.sizes.viewport.width <= 600 ? { min: 22, max: 42 } : { min: 16, max: 30 }
        this.distance = THREE.MathUtils.clamp(this.distance, this.zoomLimits.min, this.zoomLimits.max)
    }

    zoomBy(_amount)
    {
        this.distance = THREE.MathUtils.clamp(this.distance + _amount, this.zoomLimits.min, this.zoomLimits.max)
    }

    reveal(_position, _player)
    {
        this.player.copy(_player)
        this.focus.copy(this.targetEased)
        this.revealing = true
        gsap.killTweensOf(this.focus)

        this.revealTimeline?.kill()
        this.revealTimeline = gsap.timeline({
            onComplete: () =>
            {
                this.revealing = false
            }
        })
        this.revealTimeline
            .to(this.focus, { x: _position.x, y: _position.y, z: 0, duration: 1.1, ease: 'power2.inOut' })
            .to(this.focus, { duration: 1.15 })
            .to(this.focus, {
                x: () => this.player.x,
                y: () => this.player.y,
                z: 0,
                duration: 1.1,
                ease: 'power2.inOut',
                onUpdate: () => this.target.copy(this.focus)
            })

        this.revealTimeline.eventCallback('onUpdate', () => this.target.copy(this.focus))
    }
}
